(ns frontend.state.nylas
  (:require
   [clojure.string :as string]
   [common.email :as email]
   [frontend.db :as app-db]
   [goog.string :as gs]))

(defn clean-email
  [em]
  (let [plus (string/index-of em "+")
        at (string/index-of em "@")]
    (if (or (not (number? plus))
            (not (pos? plus)))
      em
      (string/trim (str (subs em 0 plus) (subs em at))))))

(defn window-closer
  [args]
  (when (= "nylas-callback/ok" (.-data args))
    (when-let [w (get-in @app-db/app-state [:nylas :popup])]
      (.close w))
    (.removeEventListener js/window "message" window-closer false)
    (swap! app-db/app-state dissoc [:nylas])))


(defn connect-nylas
  [email]
  (let [cleaned-email (clean-email email)
        cleaned-email (cond (string/ends-with? cleaned-email "@gmail.com")
                            ""
                            (not (email/valid-email? email))
                            ""
                            :else
                            cleaned-email)]

    (.addEventListener js/window "message" window-closer false)
    (let [url (gs/format "https://api.nylas.com/oauth/authorize?client_id=%s&response_type=code&scopes=email&login_hint=%s&redirect_uri=%s"
                         (:nylas/app-id @app-db/app-state)
                         cleaned-email
                         (js/encodeURIComponent (str (:server-url @app-db/app-state) "/nylas/api/callback")))]
      (if true
        (js/console.log "URL : " url)
        (aset js/window.location
              "href"
              url)))))
